import React from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledContainer = styled(Box)(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: 200,
    padding: theme.spacing(4),
    gap: theme.spacing(2),
}));

interface LoadingStateProps {
    message?: string;
    size?: number;
}

export const LoadingState: React.FC<LoadingStateProps> = ({
    message = 'Chargement des données...',
    size = 40,
}) => {
    return (
        <StyledContainer>
            <CircularProgress size={size} />
            <Typography variant="body1" color="text.secondary">
                {message}
            </Typography>
        </StyledContainer>
    );
};

export default LoadingState;
